export default __webpack_public_path__ + "static/media/integrity-temp-grip.da4ea41f.svg";